import LoadScene from '@scenes/LoadScene';
import StartScene from '@scenes/StartScene';
import GameScene from '@scenes/GameScene';
import UIScene from '@scenes/UIScene';
import EndScene from '@scenes/EndScene';

export default [
  { key: 'LoadScene', scene: LoadScene, autoStart: true },
  { key: 'StartScene', scene: StartScene },
  { key: 'GameScene', scene: GameScene },
  { key: 'UIScene', scene: UIScene },
  { key: 'EndScene', scene: EndScene },
];
